import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogContentText } from "@mui/material"
import React, { useState } from "react";
import { DeleteButton } from "../../../app/components/DeleteButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { deleteSystemSetting } from "./systemSettingsApi";
import { useAppDispatch } from "../../../app/hooks";
import { showError, showSuccess } from "../../notifications/notificationsSlice";

interface DeleteSystemSettingsDialogProps {
    systemSettingId: string;
    onSaveSuccess: (systemSetting: string) => void;
    onCancel: () => void;
}

export const DeleteSystemSettingsDialog: React.FC<DeleteSystemSettingsDialogProps> = ({ systemSettingId, onSaveSuccess, onCancel }) => {
    const dispatch = useAppDispatch();
    
    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleConfirm = async () => {
        try {
            const result = await dispatch(deleteSystemSetting(systemSettingId))
            if (deleteSystemSetting.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSaveSuccess(systemSettingId);
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    <Localized id="confirm-delete">
                        <span>Czy napewno chcesz usunąć?</span>
                    </Localized>
                </DialogContentText>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <DeleteButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>
    )
}